import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TermsPageComponent } from './terms.page';

const routes: Routes = [
  {
    component: TermsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class TermsPageRoutingModule {}
